// import Vue from "vue";
import Vuex from 'vuex';
import index from './modules/index';
import login from './modules/login';
import menu from './modules/menu';
import table from './modules/table';
export default new Vuex.Store({
    modules: {
        index,
        login,
        menu,
        table
    }
});